<template>
  <div
    :class="[
      cn(
        'flex cursor-pointer py-2 px-4 border items-center rounded-lg font-medium select-none transition-all duration-150 ease-in h-12',
        props.class
      ),
      {
        'bg-brand-primary_alt border-brand text-brand-secondary': selected,
        'border-secondary bg-white text-secondary': !selected,
      },
    ]"
  >
    <span class="truncate">
      {{ label }}
    </span>
    <Icon
      v-if="icon && selected"
      :name="icon"
      class="ltr:ml-auto rtl:mr-auto"
    />
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { cn } from "@/Utils/cn";

const props = defineProps({
  label: { type: String, required: true },
  selected: { type: Boolean, required: false },
  icon: { type: String, required: false },
  class: { type: String, required: false },
});
</script>
